/** True em macOS/iOS, onde o atalho de comando é a tecla ⌘ (no resto é Ctrl). */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  const platform = nav.userAgentData?.platform || nav.platform || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

/** Rótulo do atalho de busca global: "⌘K" no Mac, "Ctrl K" nos demais. */
export function searchShortcutLabel(): string {
  return isApplePlatform() ? '⌘K' : 'Ctrl K';
}
